import { window } from 'browser-monads';
import AbstractAnalytics from "./abstract-analytics";
import { EventArgs, EventValues } from "./analytics";

export default class MockAnalytics extends AbstractAnalytics {

    private readonly events: EventArgs[] = [];

    public getEventName(): string {
		return EventValues.GAEvent;
	}
    
    public push(eventArgs: EventArgs): void {
        this.events.push(eventArgs);
        window.analyticsEvents = this.events;
		console.table(this.events);
	}

}
